module.exports = __webpack_public_path__ + "a806b65a33b44461e69bcc0fa23640a2.svg";